import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { Expansible, TabsView, Input } from 'components'
import { formatAndValidate, generateRandomKey } from 'utils'
import API from 'api'
import { types } from 'screens/provider/experienceCreation/ExperienceForm/formReducer/consts'

const styles = makeStyles(theme => ({
  regularSection: {
    background: theme.palette.primary.light,
    borderRadius: 8,
    padding: theme.spacing(3, 4),
    boxShadow: `0px 0px 7px 2px rgba(0, 0, 0, 0.21),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)`,
    margin: theme.spacing(1, 0),
  },
}))

export default function Form({ fieldsById, sections, dispatcher, id = null }) {
  const classes = styles()

  const AutoSave = async (fieldsById, fieldId, sections, event) => {
    if (id) {
      const acceptedTypes = [
        `certificate_tourist_trust_show`,
        `s_certificate_show`,
        `q_certificate_show`,
        `turismo_sustentable`,
        `servicio_accesible`,
        `sello_turismo_social`,
        'localizacion',
        'gmaps',
        'title',
        'short_description',
        'long_description',
        'map_location',
        'included_services',
        'not_included_services'
      ]
      if (acceptedTypes.includes(fieldId)) {
        const payload = { experienceId: id, fieldId, answer: event.value }
        await new API({
          endpoint: `SavePropToEvent`,
          data: payload,
        }).send()
      }
      return true
    }
    const eventToSend = {
      ...event,
      rawValue: fieldId === `image_id` ? { ...event.rawValue, filesLoaded: null } : event.rawValue,
    }
    const obj = {
      fieldsById: { ...fieldsById, [fieldId]: { ...fieldsById[fieldId], ...eventToSend } },
      sections,
    }

    console.log(obj);
    await new API({
      endpoint: `AutoSave`,
      data: { obj },
    }).send()
    return true
  }

  function setInputValue(fieldId) {
    
    return function setValue(event) {
      const { onChange: onChangeAction, onChangeType, rules } = fieldsById[fieldId]
      if (rules) {
        event = formatAndValidate({ event, field: fieldsById[fieldId] })
      }
      if (onChangeType || onChangeAction) {
        if (onChangeAction) {
          return onChangeAction({ onChangeType, event, fieldId })
        }
        return dispatcher({
          type: onChangeType,
          payload: event,
        })
      }
      dispatcher({
        type: types.setInputValue,
        payload: event,
      })
      AutoSave(fieldsById, fieldId, sections, event)
    }
  }

  function makeRequest({ requestData, fieldId }) {
    const {
      request,
      types: { start, success },
    } = requestData
    dispatcher({ type: start, meta: fieldId })
    request.send().then(({ data }) => dispatcher({ type: success, payload: data, meta: fieldId }))
  }

  function callDidMountRequest({ fieldId, didMount: requestData }) {
    makeRequest({ requestData, fieldId })
  }

  // eslint-disable-next-line
  return (
    <Grid container alignItems="flex-start" alignContent="flex-start">
      {sections.map(({ type, ...sectionProps }, panelIndex) => {
        if (type === `regularSection`) {
          return (
            <Grid
              container
              key={generateRandomKey(`regular-section`)}
              alignItems="flex-start"
              alignContent="flex-start"
              className={classes.regularSection}
            >
              {sectionProps.fieldsIds.map((fieldId, index) => (
                <Input
                  {...fieldsById[fieldId]}
                  id={fieldId}
                  fieldsById={fieldsById}
                  didMountDispatcher={callDidMountRequest}
                  valueListener={setInputValue}
                  key={`input-${fieldId}-${index}`}
                />
              ))}
            </Grid>
          )
        }
        if (type === `section`) {
          return (
            <Expansible {...sectionProps} key={generateRandomKey(`panel-${panelIndex}`)}>
              {sectionProps.fieldsIds.map((fieldId, index) => {
                if (fieldId === `languagesAvailable`) {
                  return <></>
                }
                return (
                  <Input
                    {...fieldsById[fieldId]}
                    id={fieldId}
                    fieldsById={fieldsById}
                    didMountDispatcher={callDidMountRequest}
                    valueListener={setInputValue}
                    key={generateRandomKey(`input-${fieldId}`)}
                  />
                )
              })}
            </Expansible>
          )
        }
        if (type === `tabs`) {
          return (
            <TabsView
              {...sectionProps}
              fieldsById={fieldsById}
              didMountDispatcher={callDidMountRequest}
              valueListener={setInputValue}
              key={generateRandomKey(`tabView`)}
              dispatcher={dispatcher}
            />
          )
        }
        return null
      })}
    </Grid>
  )
}
